import { defineMigrations } from "@tldraw/store";
const groupShapeProps = {};
const groupShapeMigrations = defineMigrations({});
export {
  groupShapeMigrations,
  groupShapeProps
};
//# sourceMappingURL=TLGroupShape.mjs.map
